import { FC } from "react";
import { NotificationDTO } from "../../../../domain/models/dto/NotificationDTO";
import CreateCommentIconSVG from "../../../resources/svg/CreateCommentIconSVG";
import { useTranslation } from "react-i18next";
import { getNotificationCreatedTime } from "../../../../slices/notifications-slice";
import CreateReviewPopup from "../../../resources/components/review-components/CreateReviewPopup";
import useCurrentReview from "../../../../custom-hooks/domain/useCurrentReview";
import { getUserFirstName } from "../../../../slices/user-slice";

interface ReviewCreateCardProps {
    notification: NotificationDTO;
    onClick: () => void;
}

const ReviewCreateCard: FC<ReviewCreateCardProps> = (props) => {
    const { t } = useTranslation();
    const { isModalVisible, setModalVisible, currentReview, subject } = useCurrentReview(props.notification);

    const onCardClick = () => {
        setModalVisible(true);
        props.onClick();
    };

    return (
        <>
            <div
                onClick={onCardClick}
                className="flex group cursor-pointer border-b border-b-textFaded pb-4 mb-3 dmax2:mb-2"
            >
                <div className="flex">
                    <CreateCommentIconSVG className="min-w-8 min-h-8 text-textFaded group-hover:text-textWhite transition duration-300 mr-3" />
                    <div className="flex flex-col">
                        <div className="flex gap-[30px] dmax2:gap-[10px]">
                            <p className="H20 dmax2:H14B text-textWhite">
                                {currentReview
                                    ? t("reviews.successMessage")
                                    : t(`notifications.${props.notification.type}`) + " " + getUserFirstName(subject)}
                            </p>
                            <div className="H16 dmax2:H14 text-textFaded text-nowrap">
                                {getNotificationCreatedTime(t, props.notification, true)}
                            </div>
                        </div>
                        <p className="H16B dmax2:H14 text-textWarning mt-[10px] dmax2:mt-1 [word-break:break-word]">
                            {props.notification.application?.work.title}
                        </p>
                    </div>
                </div>
            </div>
            <CreateReviewPopup
                isVisible={isModalVisible}
                setVisible={setModalVisible}
                notification={props.notification}
            />
        </>
    );
};

export default ReviewCreateCard;
